var exports = {
  "hZ": "MessageComponentSelect.module__trigger___OXloSn",
  "Jp": "MessageComponentSelect.module__triggerOpen___OXloSn",
  "GA": "MessageComponentSelect.module__triggerText___OXloSn",
  "qf": "MessageComponentSelect.module__placeholder___OXloSn",
  "OW": "MessageComponentSelect.module__caret___OXloSn",
  "Zg": "MessageComponentSelect.module__emoji___OXloSn",
  "Qs": "MessageComponentSelect.module__kindIcon___OXloSn",
  "m4": "MessageComponentSelect.module__roleDot___OXloSn",
  "pN": "MessageComponentSelect.module__menuSize___OXloSn",
  "LG": "MessageComponentSelect.module__menuLayer___OXloSn",
  "MK": "MessageComponentSelect.module__menu___OXloSn",
  "KY": "MessageComponentSelect.module__menuScroller___OXloSn",
  "Yq": "MessageComponentSelect.module__choice___OXloSn",
  "Vq": "MessageComponentSelect.module__choiceText___OXloSn",
  "MD": "MessageComponentSelect.module__choiceLabel___OXloSn",
  "Ux": "MessageComponentSelect.module__choiceDescription___OXloSn",
  "z6": "MessageComponentSelect.module__check___OXloSn",
};

module.exports = exports;
